import React, { useState } from 'react';
import { SpaConfiguration } from '@configuration/SpaConfiguration';
import { MultitenantProvider } from '@app/classes/MultitenantProvider';

export const Admin: React.FC = () => {
    const [apiClearEnabled, setApiClearEnabled] = useState(true);

    const clearApiCache = async () => {
        setApiClearEnabled(false);

        await SpaConfiguration.loadAsync();
        var configuration = SpaConfiguration.get();
        var response = await fetch(`${configuration.edsApi}/Portal/ClearCache`, {
            method: 'POST',
            headers: {
                ...MultitenantProvider.getFetchHeader().headers
            }
        });

        var responseJson = await response.text();

        alert(`API cache cleared. Response: ${responseJson}`);

        setApiClearEnabled(true);
    };

    return (
        <div>
            <p>Read documentation before doing any of this!</p>
            <button onClick={clearApiCache} disabled={!apiClearEnabled}>Clear API cache</button>
        </div>
    );
};